const toLocalDate = (isoDateStr) => {
  if (!isoDateStr) {
    return null;
  }
  let [year, month, day] = isoDateStr.split('-');
  year = parseInt(year);
  month = parseInt(month) - 1; // month is 0 based index
  day = parseInt(day);
  return new Date(year, month, day);
};

const fromLocalDate = (localDate) => {
  if (!localDate) {
    return null;
  }
  let year = '0000' + localDate.getFullYear();
  let month = '0' + (localDate.getMonth() + 1); // month is 0 based index
  let day = '0' + localDate.getDate();
  year = year.substr(-4);
  month = month.substr(-2);
  day = day.substr(-2);
  return `${year}-${month}-${day}`;
};

const fieldIsVisible = (field, groupIds) => {
  // determine if a field is visible based on user groups
  // assumed that the user is already restricted (restrict_custom_fields)
  if (field.groups.length === 0) {
    // no group access, hide
    return false;
  }
  const fieldGroupIds = field.groups.map((g) => g.group_id);
  // is if any IDs are in both lists
  const intersection = fieldGroupIds.filter((e) => groupIds.includes(e));
  if (intersection.length == 0) {
    // no match to current user groups
    return false;
  }
  return true;
};

const errorsFromMutate = (error) => {
  // handler that parses our standard API error structure from axios
  // and returns a list of errors that can be easily passed to setError
  //
  // TODO: add support for "__all__" keyed errors and other
  // statuses (401 or 500)
  //
  // This util assumes that all useForm field names are one-to-one with the
  // field names on the server, including nested fields following useForm index
  // pattern (Example: nested_field.0.field_name)
  let errors = [];
  if (error.response.status === 400) {
    const data = error.response.data;
    // example of 400/validation error
    // {
    //     "first_name": [
    //         "This field is required."
    //     ]
    // }
    //
    // Nested 400 example
    // {
    //     "fields": {
    //         "fields-0": {
    //             "label": [
    //                 "This field is required."
    //             ]
    //         }
    //     }
    // }
    Object.keys(data).forEach((k) => {
      if (Array.isArray(data[k])) {
        if (k == '__all__') {
          errors.push({
            field: '__all__',
            error: {
              type: 'custom',
              message: data[k]?.join(', '),
            },
          });
        }
        // list of errors on the field
        // set first error returned on field
        errors.push({
          field: k,
          error: {
            type: 'custom',
            message: data[k][0], // first error
          },
        });
      } else if (typeof data[k] === 'object') {
        // nested errors
        Object.keys(data[k]).forEach((nestedk) => {
          let [fieldName, index] = nestedk.split('-');
          Object.keys(data[k][nestedk]).forEach((nestedField) => {
            errors.push({
              field: `${fieldName}.${index}.${nestedField}`,
              error: {
                type: 'custom',
                message: data[k][nestedk][nestedField][0], // first error
              },
            });
          });
        });
      }
    });
  } else if (error.response.status === 500) {
    errors.push({
      field: '__all__',
      error: {
        type: 'custom',
        message: 'Internal Server Error',
      },
    });
  }
  return errors;
};

export { errorsFromMutate, fieldIsVisible, fromLocalDate, toLocalDate };
